const rawLayoutOrientation = {
	// Legacy
	'Linear Grill Island': [0],
	// Current
	'Linear Bar Island': [0],
	'Galley': [0, 180],
	'L-Shaped Left Aligned': [0, -90],
	'L-Shaped Right Aligned': [0, 90],
	'L-Shaped Grill Left': [0, 90],
	'L-Shaped Grill Right': [0, -90],
	'L-Shaped Bar Left': [0, -90],
	'L-Shaped Bar Right': [0, 90],
	'L-Shaped With Corner, Grill Left': [0, 45, 90],
	'L-Shaped With Corner, Grill Right': [0, -45, -90],
	'L-Shaped With Corner, Bar Left': [0, -45, -90],
	'L-Shaped With Corner, Bar Right': [0, 45, 90],
	'Linear': [0],
	'Side-by-Side Grill Left': [0, 0],
	'Side-by-Side Grill Right': [0, -360],
	'Side-by-Side Bar Left': [0, -360],
	'Side-by-Side Bar Right': [0, 0],
	'U-Shaped': [0, -90, 90],
	'U-Shaped With One Corner Island On Left': [0, -45, -90, 90],
	'U-Shaped With One Corner Island On Right': [0, -90, 45, 90],
	'U-Shaped With Two Corner Islands': [0, -45, -90, 45, 90]
};

export const getRawLayoutOrientationMap = (layoutKey: string): [number, number] => {
	return rawLayoutOrientation[layoutKey];
};
